import clsx from 'clsx'
import type { ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// our font sizes are plain lengths (text-[16px]) that leave the line height alone, so a font size
// must not remove a leading-* class that precedes it
const twMerge = extendTailwindMerge({
  override: { conflictingClassGroups: { 'font-size': [] } },
})

/**
 * Joins class names, with support for conditional ones in object notation: cn('a', { b: condition }).
 * When two Tailwind classes set the same property, the later one wins.
 */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs))
